import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from 'components/CncUI/Button';
import Modal from 'components/CncUI/Modal';
import TextField from 'components/CncUI/TextField';
import FeedbackButton from 'components/FeedbackButton';

const useStyles = makeStyles(({ breakpoints }) => ({
  content: {
    [breakpoints.up('sm')]: {
      width: 500,
    },
  },
}));

const Submit = ({ onClose, onConfirm, open, country }) => {
  const classes = useStyles();
  const [name, setName] = useState('');

  const confirm = () => onConfirm(name).then(onClose);
  const title = country === 'CAN' ? 'TD1' : 'W-4';

  return (
    <Modal
      id="SubmitModal"
      open={open}
      onClose={onClose}
      aria-labelledby="SubmitHeader"
    >
      <Modal.Title id="SubmitHeader">Name this {title} document</Modal.Title>
      <Modal.Content className={classes.content}>
        <Modal.ContentText>
          Ensure that each field has been filled out correctly. You won't be
          able to edit this {title} after saving.
        </Modal.ContentText>
        <TextField
          fullWidth
          label="File Name (optional)"
          value={name}
          onChange={ev => setName(ev.target.value)}
          inputProps={{ maxLength: 255 }}
          id="SubmitNameField"
        />
      </Modal.Content>
      <Modal.Actions>
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button secondary onClick={onClose} id="SubmitCancelButton">
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <FeedbackButton
              id="SubmitSaveButton"
              onClick={confirm}
              errorMessage={`There was an error submitting your ${title}. Please try again later or contact product support if the issue persists.`}
            >
              Save {title}
            </FeedbackButton>
          </Grid>
        </Grid>
      </Modal.Actions>
    </Modal>
  );
};

export default Submit;
